import { FieldMeta } from '@/modules/dynamic-form/models/FieldMeta.model';
import { FieldSchema } from '@/modules/dynamic-form/models/FieldSchema.model';

export function createAdditionalInsuredEndorsementFieldMeta(schema: FieldSchema): FieldMeta {
    return {
        ...schema,
        defaultValue: {
            endorsementType: 'ADDITIONAL_INSURED',
            additionalInsuredEndorsementType: 'FORM_NUMBER',
            formNumber: undefined,
            details: {
                additionalInsuredType: 'NAMED',
                additionalInsuredName: undefined,
            },
        },
    };
}
